export function parseRoomIdFromPath(pathname: string): string | null {
  const match = pathname.match(/\/messages\/([^/]+)/);
  return match ? match[1] : null;
}

export function isRoomView(pathname: string): boolean {
  return (
    pathname.startsWith('/messages/') && pathname !== '/messages' && pathname !== '/messages/notes'
  );
}

export function isOverview(pathname: string): boolean {
  return pathname === '/messages';
}
